<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('common.id')"
    class="id-filter"
    optional
  >
    <RygenIdFilter :id="inputId" v-model="internalValue.ids" />
  </InputWrapper>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { OrderSearchCriteria, ShipmentSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import RygenIdFilter from '@rygen/rygen-ui/components/search/IdFilter.vue';

const internalValue = defineModel({
  type: Object as PropType<OrderSearchCriteria | ShipmentSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();
</script>
